import { render, staticRenderFns } from "./AnamnesiViewComponent.vue?vue&type=template&id=7a74de65"
import script from "./AnamnesiViewComponent.vue?vue&type=script&lang=js"
export * from "./AnamnesiViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports